<template>
  <div>
    <div v-if="cobrancaProducts.length">
      <b-card class="shadow-sm" no-body>
        <b-tabs class="tabsScroll" pills>
          <b-tab
            v-for="(c, index) in cobrancaProducts.filter(p => p.contratos || p.produtoDTO.nome !== 'TÍTULOS DESCONTADOS')"
            :key="index"
          >
            <template #title>{{ index + 1 }}ª</template>
            <div class="associate__info__rows__group">
              <h3 class="associate__info__rows__group__title">Cobrança</h3>

              <div v-if="c.produtoDTO.nome !== 'TÍTULOS DESCONTADOS'">
                <div class="row__container">
                  <p class="row__type">Produto</p>
                  <p class="row__description">{{ c.produtoDTO.nome.toLowerCase() || '-' }}</p>
                </div>
                <div class="row__container">
                  <p class="row__type">Operação</p>
                  <p class="row__description">{{ c.operacao || '-' }}</p>
                </div>
                <div class="row__container">
                  <p class="row__type">Dias Em Atraso</p>
                  <p class="row__description">{{ c.diasAtraso || '-' }}</p>
                </div>
                <div class="row__container">
                  <p class="row__type">Valor</p>
                  <p class="row__description">{{ onFormatMoney(c.valor) }}</p>
                </div>
              </div>

              <div v-else>
                <div class="row__container">
                  <p class="row__type">Produtos</p>
                  <p class="row__description">{{ c.modalidadeBacen.toLowerCase() || '-' }}</p>
                </div>
                <div class="row__container">
                  <p class="row__type">Operações</p>
                  <p class="row__description">
                    <span v-if="c.contratos">
                      <i class="fas fa-info-circle" v-b-tooltip.hover :title="'Operação: ' + c.contratos.join(', ')"></i>
                      <button class="btn btn-link p-0 ml-2" style="text-decoration: underline; color: #04a791;" @click="$emit('scrollToContratosVigentes')">
                        VER MAIS
                      </button>
                    </span>
                    <span v-else>{{ c.operacao || '-' }}</span>
                  </p>
                </div>
                <div class="row__container">
                  <p class="row__type">Valor Total</p>
                  <p class="row__description">{{ onFormatMoney(c.valorContrato) }}</p>
                </div>
              </div>

              <DefaultButton
                btnVariant="btn-third justify-content-center"
                :onClick="() => openCard(c.cardDTO.id)"
                text="Ver Card"
              />
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
    <div v-else>
      <b-card class="shadow-sm text-center py-5" style="min-height: 120px;">
        <div class="sem-cobranca-msg">
          <i class="fas fa-info-circle fa-2x mb-2" style="color: #04a791;"></i>
          <div style="font-size: 1.2rem; font-weight: 500; color: #666;">
            Não possui cobrança
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import CardRepository from '@/shared/http/repositories/crm/card.js'
import CardProductRepository from '@/shared/http/repositories/crm/cardproduct.js'
import boardTypes from '@/enums/enumBoardTypes.js'
import Tools from '../../../../components/tools/Tools'

export default {
  props: {
    document: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      cobrancaProducts: [],
      boardTypes: boardTypes,
      financeResume: {
        contracts: [],
        accounts: [],
        cobrancaProducts: [],
        ajuizamento: []
      }
    }
  },
  async mounted () {
    await this.onLoadCardsFromAssociate(this.document)
  },
  methods: {
    async onLoadCardsFromAssociate (document) {
      await CardRepository.SearchAllByDocument(document, 'situacao=ATIVO', 200, 0)
        .then(async response => {
          const cards = response.data.content
          let cardsCobranca = this.splitCardsByType(cards, this.boardTypes.COBRANCA)
          let cardsAjuizamento = this.splitCardsByType(cards, this.boardTypes.AJUIZAMENTO)

          this.financeResume.cards = {
            cobranca: cardsCobranca,
            ajuizamento: cardsAjuizamento
          }

          const cobrancaProducts = await this.getProdutosFromCobranca(cardsCobranca)

          const titulosDescontados = cobrancaProducts.filter(
            product => product.produtoDTO.nome === 'TÍTULOS DESCONTADOS'
          )

          if (titulosDescontados.length > 0) {
            const consolidatedProduct = {
              produtoDTO: { nome: 'TÍTULOS DESCONTADOS' },
              contratos: titulosDescontados.map(t => t.operacao),
              valorContrato: titulosDescontados.reduce((sum, t) => sum + (t.valor || 0), 0),
              modalidadeBacen: 'TÍTULOS DESCONTADOS'
            }

            cobrancaProducts.push(consolidatedProduct)
          }

          this.cobrancaProducts = cobrancaProducts
        })
        .catch(err => {
          console.error(err)
        })
    },
    async getProdutosFromCobranca (cards) {
      const allProducts = []
      for (const card of cards) {
        try {
          const response = await CardProductRepository.Search(card.id, 200, 0)
          allProducts.push(...response.data.content)
        } catch (err) {
          console.error(err)
        }
      }
      return allProducts
    },
    onFormatMoney (value) {
      return value || value === 0 ? Tools.formatMoneyBR(value) : 'R$ 0,00'
    },
    openCard (cardId) {
      // Emit or handle as needed
      this.$emit('openCard', cardId)
    },
    splitCardsByType (cards, type) {
      let cardsFromType = []
      cards.forEach((card) => {
        if (card.boardColumn.board.tipoBoard === type) {
          cardsFromType.push(card)
        }
      })
      return cardsFromType
    }
  }
}
</script>

<style scoped>
.associate__info__rows__group__title {
  font-size: 1.15rem;
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 0.25rem;
}
.row__container {
  margin-bottom: 10px;
}
.row__type {
  font-weight: bold;
  margin-bottom: 2px;
}
.row__description {
  text-transform: capitalize;
}
.sem-cobranca-msg {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.tabsScroll .nav-pills .nav-item {
  margin-right: 12px !important;
}

.tabsScroll .nav-pills .nav-item:last-child {
  margin-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/associate/components/AssociateCobranca.vue